import Grid from '@material-ui/core/Grid';
import { Fade, IconButton, makeStyles, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import BannerImage from '../../Images/TealRefquestionnaire.png'

const useStyles = makeStyles((theme) => ({
    root: {
        // flexGrow: 1,
    },
    bannerImg: {
        backgroundSize: 'cover',
        width: '100vw',
        // height: '257px'
    },
    checkcircle: {
        color: 'rgba(46, 177, 80)',
        fontSize: '50px'
        // width: 45
    },
    iconbutton: {
        color: 'rgba(46, 177, 80,0.3)',
        backgroundColor: 'rgba(46, 177, 80,0.2)'
    }

}))


export default function AcknowledgeForm() {
    const classes = useStyles();
    return (
        <div>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <img src={BannerImage} alt='CRF' className={classes.bannerImg} />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <IconButton size='small' className={classes.iconbutton}><CheckCircleIcon className={classes.checkcircle} /></IconButton>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h4' style={{ fontFamily: 'inherit', textAlign: 'center', paddingBottom: ' 13px' }}>Your response has been recorded successfully!</Typography>
                    <Typography variant='h4' style={{ fontFamily: 'inherit', textAlign: 'center' }} >We will get in touch with you via email if anything else is needed</Typography>
                </Grid>

            </Grid>
        </div>

    )
}

